import { render, staticRenderFns } from "./NavbarFront.vue?vue&type=template&id=6470c0dc&"
import script from "./NavbarFront.vue?vue&type=script&lang=js&"
export * from "./NavbarFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports